import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text, TextStyles, designTokens } from "@cinch-labs/design-system";
import cx from "classnames";
import Car from "./assets/car.svg";
import styles from "./holding-image.module.css";
var space = designTokens.customProperties.ds.space;
export var HoldingImage = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _text = param.text, text = _text === void 0 ? "" : _text;
    return /*#__PURE__*/ _jsxs("div", {
        className: cx(styles["holdingImage"], className),
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: styles["icon"],
                children: /*#__PURE__*/ _jsx(Car, {
                    fill: "currentColor",
                    width: space["8-x"]
                })
            }),
            /*#__PURE__*/ _jsx(Text, {
                type: TextStyles.menuTitle,
                children: text
            })
        ]
    });
};
export default HoldingImage;
